import { Form } from 'antd';
import { useCallback, useState } from 'react';

import { CalendarModalContext } from '@app/providers/CalendarModalProvider/CalendarModalContext';
import type { CalendarModalProviderProps } from '@app/providers/CalendarModalProvider/CalendarModalProvider.types';
import type { TEmployee, NSchedule, TWorkBreak } from '@app/types';

import type { FC } from 'react';

const { useForm } = Form;

export const CalendarModalProvider: FC<CalendarModalProviderProps> = ({
  children,
}) => {
  const [lastClickedEmployeeData, setLastClickedEmployeeDataState] =
    useState<TEmployee | null>(null);
  const setLastClickedEmployeeData = useCallback((employee: TEmployee) => {
    setLastClickedEmployeeDataState(employee);
  }, []);

  const [lastClickedWorkBreak, setLastClickedWorkBreakState] =
    useState<TWorkBreak | null>(null);
  const setLastClickedWorkBreak = useCallback((workBreak: TWorkBreak) => {
    setLastClickedWorkBreakState(workBreak);
  }, []);

  const [isWorkScheduleModalOpen, setIsWorkScheduleModalOpen] = useState(false);
  const [isWorkScheduleModalLoading, setIsWorkScheduleModalLoading] =
    useState(false);
  const [breakModalType, setBreakModalType] = useState('');
  const [isBreakModalOpen, setIsBreakModalOpen] = useState(false);
  const [isBreakModalLoading, setIsBreakModalLoading] = useState(false);
  const [editEmployeeScheduleModalType, setEditEmployeeScheduleModalType] =
    useState('');
  const [
    isEditEmployeeScheduleModalLoading,
    setIsEditEmployeeScheduleModalLoading,
  ] = useState(false);
  const [isEditEmployeeScheduleModalOpen, setIsEditEmployeeScheduleModalOpen] =
    useState(false);
  const [
    editEmployeeScheduleModalEditingAlertString,
    setEditEmployeeScheduleModalEditingAlertString,
  ] = useState('');
  const [
    editEmployeeScheduleModalDeletingAlertString,
    setEditEmployeeScheduleModalDeletingAlertString,
  ] = useState('');
  const [
    editEmployeeScheduleModalInitialEditingData,
    setEditEmployeeScheduleModalInitialEditingData,
  ] = useState<NSchedule.ModelEmployeeDateWorkSchedule | null>(null);
  const [editingWorkScheduleForm] =
    useForm<NSchedule.EditingWorkScheduleFormProps>();
  const [breakForm] = useForm();

  return (
    <CalendarModalContext.Provider
      value={{
        lastClickedEmployeeData,
        setLastClickedEmployeeData,
        lastClickedWorkBreak,
        setLastClickedWorkBreak,
        isWorkScheduleModalOpen,
        setIsWorkScheduleModalOpen,
        isWorkScheduleModalLoading,
        setIsWorkScheduleModalLoading,
        breakModalType,
        setBreakModalType,
        isBreakModalOpen,
        setIsBreakModalOpen,
        isBreakModalLoading,
        setIsBreakModalLoading,
        editEmployeeScheduleModalType,
        setEditEmployeeScheduleModalType,
        isEditEmployeeScheduleModalLoading,
        setIsEditEmployeeScheduleModalLoading,
        isEditEmployeeScheduleModalOpen,
        setIsEditEmployeeScheduleModalOpen,
        editEmployeeScheduleModalEditingAlertString,
        setEditEmployeeScheduleModalEditingAlertString,
        editEmployeeScheduleModalDeletingAlertString,
        setEditEmployeeScheduleModalDeletingAlertString,
        editEmployeeScheduleModalInitialEditingData,
        setEditEmployeeScheduleModalInitialEditingData,
        editingWorkScheduleForm,
        breakForm,
      }}
    >
      {children}
    </CalendarModalContext.Provider>
  );
};
